import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StorageShelfApi } from '../api/storageshelf.api';
import { switchMap, map } from 'rxjs/operators';

import { StorageShelfData, StorageShelf } from '../../../interfaces/masters/storageshelf';
@Injectable() 
export class StorageshelfService extends StorageShelfData{

  constructor(private api: StorageShelfApi) {
    super();
  } 
  
  list(url: string): Observable<StorageShelf[]> { 
    return this.api.list(url);
  } 

  getById(url:string): Observable<StorageShelf>{
      return this.api.getById(url);
  }

  create(url: string, data:StorageShelf): Observable<StorageShelf[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:StorageShelf): Observable<StorageShelf> { 
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  //uploadData
  postData(url: string, data:any[]): Observable<any> {
    return this.api.addData(url,data);
  }
}
